// eslint-disable-next-line import/prefer-default-export
export const REMISE = {
  titre: 'Liste des remises bancaires',
  racine: 'Accueil',
  bouttonAdd: 'Créer une remise bancaire',
  recherche: 'Rechercher',
  exportReglement: 'Exporter les règlements',
  exportAnnulation: 'Exporter les annulations de paiement',
  workInProgress: 'Fonctionnalité en cours de développement',
  remise: 'Remise',
  remiseN: 'Remise N°',
  remiseBancaire: 'Remise bancaire',
  validation: 'Valider la remise',
  devalidation: 'Dévalider la remise',
  titleAccesRapide: 'Accès rapide',
  generateEcriture: 'MAJ Ecriture',
  visuAchat: 'Journal des écritures',
  remiseBancaireAdd: '1 remise(s) bancaire(s) créée(s)',
  generatePrelevement: 'Générer prélèvement',
  reglement: {
    titre: 'Exporter les règlements',
    du: 'Du',
    au: 'au',
  },
  annulation: {
    titre: 'Exporter les annulations de paiement',
    du: 'Du',
    au: 'au',
  },
  dataTable: {
    nom: 'Nom',
    modeReglement: 'Mode de règlement',
    etat: 'Etat',
    remiseEffet: 'Remise d\'effet',
    nbReglement: 'Nb règlts',
    montant: 'Montant TTC',
    num: 'N° de remise',
    date: 'Date',
    banque: 'Banque',
    delete: 'Supprimer',
    cancel: 'Annuler',
    euros: '€',
    enCours: 'En cours',
    valide: 'Validée',
  },
  ajoutRemise: {
    titre: 'Créer une remise bancaire',
    banque: 'Banque',
    placeholderBanque: 'Liste des banques',
    annuler: 'Annuler',
    nomRemise: 'Nom de la remise',
    placeholderNomRemise: 'Texte',
    modeReglement: 'Mode de règlement',
    dateRemise: 'Date de la remise',
  },
  detailRemiseBancaire: {
    referenceTire: 'Référence tiré',
    nomTire: 'Nom tiré',
    dateReglement: 'Date de règlement',
    dateEffet: 'Date d\'effet',
    montant: 'Montant',
    client: 'Client',
    commentaire: 'Commentaire',
  },
  ajoutReglement: {
    titre: 'Ajouter un règlement',
    titreModification: 'Modifier un règlement',
    ajouterUnAutre: 'Ajouter un autre',
    annuler: 'Annuler',
    deleteReglement: 'Règlement supprimé',
    clientOuCompteComptable: 'Client ou compte comptable',
    numeroFacture: 'N° de facture',
    nomTire: 'Nom tiré',
    montantTtc: 'Montant TTC',
    referenceTire: 'Référence tiré',
    dateReglement: 'Date de règlement',
    dateEffet: 'Date d\'effet',
    facture: 'Libellé',
    avoir: 'Avoir',
    acompte: 'Acompte',
    banque: 'Banque :',
    'modeReglement:': 'Mode de règlement :',
    informationRemiseBancaire: 'Informations de la remise bancaire',
    inProgress: 'En cours',
    valide: 'Validée',
    modeReglement: 'Mode de règlement',
    type: 'Type',
    dateEcheance: 'Date d\'échéance',
    solde: 'Solde',
    soldeAu: 'Solde au {date} ',
    montantRestantTtc: 'Montant restant TTC',
    montant: 'Montant échéance TTC',
    inputLetterage: 'Montant à affecter TTC',
    montantAffecte: 'Montant affecté TTC',
    montantsAvoirs: 'Montants avoirs TTC',
    montantrestant: 'Le montant restant à lettrer ({resteALettrer}€) sera ajouté au solde du client.',
    montantInferieur: 'Le montant du règlement est inférieur aux montants des factures sélectionnées.',
    montantObligatoire: 'Le montant du nouveau règlement est obligatoire',
    clientObligatoire: 'Veuillez renseigner au moins \'Client ou Compte comptable\' ou \'N° Facture\'.',
    pasEscompteEtCreditSelected: 'L\'usage d\'escompte n\'est actuellement pas compatible avec la sélection complémentaire de crédit en association du nouveau réglement. Le complement de lettrage peut être réalisé via l\'encours ou le compte tiers',
    errors: {
      amountGreaterThanMouvements: 'Le montant ne peut être supérieur à celui des mouvements',
      notLettered: 'Une des échéances de paiement est déjà lettrée',
      lettrageAmountLessZero: 'Un lettrage doit avoir un montant supérieur à 0',
      differentClient: 'Les deux mouvements d’un lettrage doivent être sur le même tiers',
      lettrageOnlyOneCreditDebitMouvement: 'Un lettrage doit se faire entre un crédit et un débit',
      lettrageOnlyOnePerMouvementPair: 'Il ne doit y avoir qu’un lettrage pour la même paire de mouvements',
    },
    info: {
      montantTtcChange: 'Le montant du règlement a été changé, veuillez vérifier vos lettrages',
    },
  },
  ajoutReglementPiece: {
    referencePiece: 'Référence pièce',
    typePiece: 'Type',
    datePiece: 'Date pièce',
    totalPiece: 'Total TTC',
    restantPiece: 'Restant dû TTC',
    soldeDe: 'Solde de {client}',
    affectation: 'Affectation',
    resteAAfeecter: 'Reste à affecter',
    inputAffecte: 'Affecté',
    soldePiece: 'Solde',
    escompte: 'Escompte',
    autresCredits: 'Crédits disponibles :',
    autresCreditsSelected: 'Crédits sélectionnés : ',
    cumulDesReglement: 'Cumul des règlements',
    creditDispo: 'Autres crédits disponibles',
    aucunCredit: 'Il y a aucun autre crédit disponible.',
  },
  detailReglementPiece: {
    title: 'Ventilation règlement',
    referencePiece: 'Référence pièce',
    typePiece: 'Type',
    datePiece: 'Date pièce',
    totalPiece: 'Total TTC',
    restantPiece: 'Restant dû TTC',
    soldeDe: 'Solde de {client}',
    affectation: 'Montant affecté',
    resteAAffecter: 'Reste à affecter',
    dateEcheance: 'Date échéance',
    montantEcheance: 'Echéance TTC',
    resteEcheance: 'Montant restant',
    modeReglement: 'Mode Rglt',
    libelleEcheance: 'Libellé',
    montantAffecte: 'Mnt affecté',
    soldeEcheance: 'Solde',
    terminer: 'Terminer',
    escompte: 'Escompte',
  },
  remisebancaireSupprime: 'Remise bancaire supprimée',
  remisebancaireSupprimeMult: 'Remises bancaires supprimées',
  indisponible: 'INDISPONIBLE',
  nonLettre: 'Montant non lettré : ',
  msgError: {
    errSuppEcritCompta: 'Une erreur s\'est produite lors du processus de suppression des écritures comptables associées',
    errDevalidRemiseBanc: 'La remise bancaire ne peut être dévalidée car des écritures comptables associées sont placées dans des lots',
    errResteAAffecter: 'Il reste {resteALettrer} € à affecter avant de terminer la ventilation',
    errTropAffecte: '{resteALettrer} € de trop sont actuellement affecté, rectification nécessaire pour terminer la ventilation',
  },
  onglet: {
    lotPaiement: 'Lot de paiement',
    remiseBancaire: 'Remise bancaire',
    ecritureCompta: 'Ecriture comptable',
    fichierPrelevement: 'Fichiers de prélèvement',
  },
  messages: {
    successGenerateEcriture: 'Ecriture mise à jour avec succès',
    successUpdate: 'La remise bancaire a été modifiée avec succès',
    successEditReglement: 'Règlement modifié avec succès',
    successAddReglement: 'Règlement ajouté avec succès',
    successGeneratePrelevement: 'Le fichier prélèvement a bien été généré. Il a été ajouté à vos fichiers de prélèvements',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    exporteeEnCompta: 'Exportée en compta',
    etat: 'Etat',
    modePaiement: 'Mode(s) de paiement',
    modeReglement: 'Mode(s) de règlement',
    banque: 'Banque(s)',
    date: 'Date remise',
    exporteeEnComptaAnswer: {
      yes: 'Oui',
      no: 'Non',
    },
  },
  errors: {
    problemOccurred: 'Un problème est survenu',
    iban: {
      length: 'La longueur de l\'IBAN du client {client} n\'est pas correct',
      countryCodeUnsupported: 'Le code de pays de l\'IBAN du client {client} n\'est pas supporté',
      countryCodeUpperCaseLetters: 'Le code du pays de l\'IBAN du client {client} doit-être en majuscule',
      invalidCheckDigitValue: 'Les chiffres de contrôle d\' l\'IBAN du client {client} sont invalides',
      genericError: 'L\'IBAN du client  {client} est incorrect',
      ibanNotEmptyOrNull: 'L\'IBAN du client {client} ne doit pas être vide',
    },
    bic: {
      length: 'Le bic du client {client} doit contenir 8 caractères ou 11 caractères',
      branchCodeOnlyLettersOrDigit: 'Le code de la branche du client {client} doit contenir seulement des lettres ou des chiffres',
      countryCodeUnsupported: 'Le code de pays du BIC du client {client} n\'est pas supporté',
      genericError: 'Le BIC du client {client} est incorrect',
      bicNotEmptyOrNull: 'Le BIC du client {client} ne doit pas être vide',
    },
    icsEmpty: 'L\'identifiant créancier SEPA de la banque est vide',
    ibanMissing: 'L\'IBAN de la banque du client {client} est vide',
    rumMissing: 'La référence unique du mandat du client {client} est vide',
    dateMandat: 'La date  de signature du mandat du client {client} est vide',
    bankName: 'Le nom de la banque de domiciliation est vide',
    bankInactive: 'La banque est inactive',
    bankHoldingEmpty: 'Le titulaire de la banque du client {client} est vide',
    bicEmpty: 'Le bic de la banque est vide',
    ibanEmpty: 'L\'IBAN de la banque est vide',
    lineEqualZero: 'Une des lignes de mouvement a un montant égal à 0',
    lineCountEmpty: 'Aucun mouvement',
    tiersMissing: 'Une des ligne de mouvement n\'a pas de client',
    bankDebit: 'Le mode de paiement doit être prélèvement',
  },
  natureReglement: {
    annulation: 'Annulation',
    impaye: 'Impayé',
  },
};

export const SUPPRESSION = {
  irreversible: 'La suppression d\'une remise bancaire est irréversible.',
  delete: 'Etes-vous sûr de vouloir supprimer cette remise bancaire ?',
  irreversibleMultiple: 'La suppression des remises bancaires est irréversible.',
  deleteMultiple: 'Etes-vous sûr de vouloir supprimer ces remises bancaires ?',
  yes: 'Oui',
  no: 'Non',
  messages: {
    errorTitle: 'Suppression de la remise bancaire impossible.',
    errorTitleMultiple: 'Suppression des remises bancaires impossible.',
    success: 'Suppression de la remise bancaire réalisée avec succès.',
    successMultiple: 'Suppression des remises bancaires réalisée avec succès.',
  },
  apiMessages: {
    STATE_DRAFT_REQUIRED_TO_DELETE: 'Suppression impossible de la remise bancaire',
  },
};

export const SUPPRESSION_REGLEMENT = {
  tooltip: 'Supprimer règlement',
  irreversible: 'La suppression d\'un règlement est irréversible.',
  delete: 'Etes-vous sûr de vouloir supprimer ce règlement ?',
  irreversibleMultiple: 'La suppression des règlements est irréversible.',
  deleteMultiple: 'Etes-vous sûr de vouloir supprimer ces règlements ?',
  yes: 'Oui',
  no: 'Non',
  messages: {
    errorTitle: 'Suppression de la remise bancaire impossible.',
    errorTitleMultiple: 'Suppression des remises bancaires impossible.',
    success: 'Suppression de la remise bancaire réalisée avec succès.',
    successMultiple: 'Suppression des remises bancaires réalisée avec succès.',
  },
  reglementSupprime: 'Règlement supprimé',
  reglementSupprimeMult: 'Règlements supprimés',
  apiMessages: {
    STATE_DRAFT_REQUIRED_TO_DELETE: 'Suppression impossible de la remise bancaire',
  },
};

export const ANNULATION_REGLEMENT = {
  tooltip: 'Annuler règlement',
  info: 'L\'annulation d\'un règlement réactivera l\'échéance de paiement de la facture.',
  cancel: 'Etes-vous sûr de vouloir annuler ce règlement ?',
  nature: 'Nature :',
  infoMultiple: 'L\'annulation des règlements est réactivera les échéances de paiement des factures.',
  cancelMultiple: 'Etes-vous sûr de vouloir annuler ces règlements ?',
  warning: 'L\'action groupée ne permet pas de générer une facture impayée',
  yes: 'Oui',
  no: 'Non',
  messages: {
    noLettrageTooltip: 'règlement non lettré',
    alreadyCancelledTooltip: 'règlement déjà annulé',
    cancelationReglementTooltip: 'règlement d\'annulation',
    errorTitle: 'Annulation du règlement impossible',
    errorTitleMultiple: 'Annulation des règlements impossible',
    success: 'Annulation du règlement réalisée avec succès',
    successMultiple: 'Annulation des règlements réalisée avec succès',
    forbiddenToCancelPaymentNotLettered: 'Impossible d\'annuler un règlement non lettré',
    forbiddenToCancelCancelledPayment: 'Impossible d\'annuler le règlement du {date} d\'un montant de {montant} € car il est déjà annulé',
    forbiddenToCancelCancellationOfPayment: 'Impossible d\'annuler le règlement du {date} d\'un montant de {montant} € car c\'est un règlement d\'annulation',
    forbiddenCreateOrUpdateLetteredTransaction: 'Impossible de modifier le mouvement client car il est lettré',
  },
  table: {
    libelle: 'Libellé',
    montantHt: 'Montant HT',
    tva: 'Tva',
    addLine: 'Ajouter une ligne',
  },
  reglementAnnule: 'Règlement annulé',
  reglementAnnuleMult: 'Règlements annulés',
  generateFactureImpayee: 'Générer une facture pour frais impayées',
  dateFacture: 'Date facture',
  modeReglement: 'Mode règlement',
  delaiReglement: 'Délai de règlement',
  noResult: 'Aucune ligne',
  motif: 'Motif',
  dateComptable: 'Date Comptable',

};

export const VALIDATION_REMISE_BANCAIRE = {
  irreversible: '',
  delete: 'Etes-vous sûr de vouloir valider cette remise bancaire ?',
  deleteLotPaiement: 'Etes-vous sûr de vouloir valider ce lot de paiement ?',
  yes: 'Oui',
  no: 'Non',
  messages: {
    errorTitle: 'Suppression de la remise bancaire impossible.',
    success: 'Validation de la remise bancaire réalisée avec succès.',
    successLotPaiement: 'Validation du lot de paiement réalisée avec succès.',
  },
  reglementSupprime: 'Remise Bancaire validé',
};

export const DEVALIDATION_REMISE_BANCAIRE = {
  irreversible: '',
  delete: 'Etes-vous sûr de vouloir dévalider cette remise bancaire ?',
  deleteLotPaiement: 'Etes-vous sûr de vouloir dévalider ce lot de paiement ?',
  yes: 'Oui',
  no: 'Non',
  messages: {
    errorTitle: 'Suppression de la remise bancaire impossible.',
    success: 'Dévalidation de la remise bancaire réaliséee avec succès.',
    succesLotPaiement: 'Dévalidation du lot de paiement réalisée avec succès.',
  },
  reglementSupprime: 'Remise Bancaire dévalidé',
};

export const MODIF_REMISE_BANCAIRE = {
  title: 'Modification ',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des remises bancaires',
    modif: 'Modification remise bancaire',
  },
  actions: {
    addReglement: 'Ajouter un règlement',
  },
  informations: {
    title: 'Informations remise bancaire',
    libelle: 'Libelle',
    banque: 'Banque',
    modeReglement: 'Mode de règlement',
    dateRemise: 'Date de la remise',
  },
  popUpPrevention: {
    messHeader: 'Attention, vous avez effectué des changements sur votre remise bancaire. Voulez-vous sauvegarder avant de continuer ?',
    actions: {
      goWithoutSave: 'Ne pas sauvegarder',
      goWithSave: 'Sauvegarder',
    },
  },
};

export const DETAIL_REMISE_BANCAIRE = {
  messages: {
    info: {
      sousTitreRemiseBancaireEmpty: 'Modifier votre remise bancaire pour ajouter des règlements',
      titreRemiseBancaireEmpty: 'Aucun règlement n\'est présent dans cette remise bancaire.',
    },
  },
  informations: {
    title: 'Informations remise bancaire',
    libelle: 'Libelle :',
    banque: 'Banque :',
    modeReglement: 'Mode de règlement :',
    dateRemise: 'Date de la remise :',
  },
};
